<template>
    <div class="client-edit-form">
        <md-dialog-alert
            :md-active.sync="saved"
            md-title="Záznam bol upravený"
            :md-content="`Klient s menom <strong>${client.name} ${client.lastname}</strong> bol úspešne upravený`" />
    
        <md-dialog-confirm
            :md-active.sync="active"
            md-title="Ste si istý ?"
            :md-content="`Chcete uložiť klienta s menom <strong>${client.name} ${client.lastname}</strong> ?`"
            md-confirm-text="Potvrdiť"
            md-cancel-text="Zrušiť"
            @md-confirm="saveClient" />
        
        <md-tabs v-if="hasClient" md-sync-route :md-dynamic-height="true">
            <md-tab id="tab-home" md-label="Upraviť klienta" :to="{'name': 'clients.detail', params: {clientId: client.id}}" exact>
    
                <div class="flex flex-wrap w-full -mx-4">
                    <div class="w-1/2 px-4">
                        <div class="flex flex-wrap -mx-4">
                            <div class="w-1/2 px-4">
                                <md-field>
                                    <label>Meno</label>
                                    <md-input v-model="client.name" />
                                </md-field>
                            </div>
                            <div class="w-1/2 px-4">
                                <md-field>
                                    <label>Priezvisko</label>
                                    <md-input v-model="client.lastname" />
                                </md-field>
                            </div>
    
                            <div class="w-1/2 px-4">
                                <md-field>
                                    <label>Telefón</label>
                                    <md-input type="phone" v-model="client.phone" />
                                </md-field>
                            </div>
                            <div class="w-1/2 px-4">
                                <md-field>
                                    <label>E-mail</label>
                                    <md-input type="email" v-model="client.email" />
                                </md-field>
                            </div>
    
                            <div class="w-full px-4">
                                <md-field>
                                    <label>Dodacia adresa</label>
                                    <md-textarea v-model="client.post_address"></md-textarea>
                                </md-field>
                            </div>

                        </div>
                    </div>
                    
                    <div class="w-1/2 px-4">
                        <div class="flex flex-wrap -mx-4">
                            <div class="w-full px-4">
                                <md-field>
                                    <label>Firma</label>
                                    <md-input v-model="client.company" />
                                </md-field>
                            </div>
    
                            <div class="w-1/3 px-4">
                                <md-field>
                                    <label>IČO</label>
                                    <md-input type="number" v-model="client.ico" />
                                </md-field>
                            </div>
    
                            <div class="w-1/3 px-4">
                                <md-field>
                                    <label>DIČ</label>
                                    <md-input type="number" v-model="client.dic" />
                                </md-field>
                            </div>
    
                            <div class="w-1/3 px-4">
                                <md-field>
                                    <label>IČ DPH</label>
                                    <md-input v-model="client.ic_dph" />
                                </md-field>
                            </div>
    
                            <div class="w-full px-4">
                                <md-field>
                                    <label>Faktúračna adresa</label>
                                    <md-textarea v-model="client.invoice_address"></md-textarea>
                                </md-field>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="justify-end flex">
                    <md-button :to="{name: 'clients.list'}">Späť na zoznam</md-button>
                    <md-button @click="() => this.active = true" class="md-primary">Uložiť</md-button>
                </div>
            </md-tab>
        
            <md-tab id="tab-pages" md-label="Projekty" :to="{'name': 'clients.detail.projects', params: {clientId: client.id}}">
                <div class="flex flex-wrap" v-if="client.projects.length > 0">
                    <ProjectItemMini v-for="project in client.projects" :project="project" :key="`miniproject${project.id}`" />
                </div>
                <div v-else>
                    <md-empty-state
                        md-icon="folder"
                        md-label="Vytvorte projekt pre klienta"
                        md-description="Po vytvorení projektu budete môcť odovzdať informácie a spolupracovať s týmom.">
                        <md-button :to="{name: 'projects.add'}" class="md-accent md-raised">Vytvorte prvý projekt</md-button>
                    </md-empty-state>
                </div>
            </md-tab>
        </md-tabs>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import ProjectItemMini from "../Project/ProjectItemMini";

    export default {
        name: "ClientEdit",
        
        components: {
            ProjectItemMini
        },
        
        data: () => ({
            saved: false,
            active: false
        }),
        
        computed: {
            ...mapState({
                client: state => state.clients.current
            }),

            hasClient() {
                return Object.keys(this.client).length > 0;
            }
        },
        
        beforeCreate() {
            this.$store.dispatch("fetchClient", this.$route.params.clientId);
        },
        
        methods: {
            saveClient() {
                this.$store.dispatch("saveClient", this.client)
                    .then(() => {
                        this.saved = true;
                    })
            },
        }
    }
</script>

<style scoped>

</style>